export const version = "address/5.7.0";
//# sourceMappingURL=_version.js.map